/*!
 * TreeView - Vue arborescence pour IconsView
 */

import BaseView from './BaseView';

export default class TreeView extends BaseView {
    constructor(plugin, name = 'tree') {
        super(plugin, name);
    }

    createContainer(element) {
        const myself = this.plugin;
        this.container = $('<ol></ol>');
        myself.container = this.container;

        myself.containerView.addClass('iv__view iv__view--' + this.name + ' view view-' + this.name);
        element.append(this.container);
        if (myself.preview) {
            element.append(myself.preview);
        }

        return this.container;
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const codeSubtext = [];
        const treeFields = myself.getViewFields(this.name);
        if (data && treeFields && treeFields.length) {
            $.each(treeFields, (indexView, view) => {
                const rawVal = (data.data && data.data[view] !== undefined) ? data.data[view] : data[view];
                if (rawVal !== undefined && rawVal !== null && rawVal != data.label) {
                    codeSubtext.push(myself.renderSubdata(rawVal, null, null, data));
                }
            });
        }

        let countTreeHtml = '';
        if (myself.shouldShowCount(data, this.name)) {
            countTreeHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        const treeIconSize = myself.getViewIconSize(this.name);
        myself.viewThumbsHeight = treeIconSize;
        myself.viewThumbsWidth = treeIconSize;
        myself.viewItemWidthRatio = 0;
        myself.viewItemThumbsMode = false;

        const code = '<li class="' + currentClassAll + '"><div class="iv__item__preframe"><div class="iv__item__expend"></div><div class="iv__item__frame iv__item__main"><span class="iv__item__link"><span class="iv__item__image" style="width:' + treeIconSize + 'px; height:' + treeIconSize + 'px;">' + myself.renderIconImage(treeIconSize, data.icon, data, 'img') + '</span> '
                + '<label class="iv__item__label">'
                + '<span class="iv__item__name titre">' + data.label + '</span>'
                + countTreeHtml
                + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                + '</label></span></div></div></li>';

        const currentIcon = $(code);
        const currentIconChilds = $('<ol class="iv__item__childs iv__item__tree"></ol>');
        currentIcon.append(currentIconChilds);
        const currentIconReact = currentIcon.find(' > div > .iv__item__main').first();

        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIconReact, data, currentType, path);
        this.renderBadge(data, currentIcon);

        // Rendu récursif des enfants
        if (data.childs && data.childs.length > 0) {
            const childsCount = myself.renderIcons(data.childs, currentIconChilds, true, path);
            if (childsCount > 0) currentIcon.addClass('iv__item--parent have-childs');

            if (myself.dataExpand[data.type + '-' + data.id] === true) {
                currentIcon.addClass('iv__item--expanded');
            } else if (myself.dataExpand[data.type + '-' + data.id] === false) {
            } else if (myself.options.expand) {
                currentIcon.addClass('iv__item--expanded');
            }
        }

        return currentIcon;
    }
}
